/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * Spinner.tsx
 */

import React from "react";
import HiloReactComponent from "../layout/HiloReactComponent";

interface Props {
    className?: string;
    large?: boolean;
}

const BLADES_NUMBER: number = 12;

export default class Spinner extends HiloReactComponent<Props, {}> {
    /**
     * render
     */
    public render(): JSX.Element {
        return <div className={`ispinner ${this.props.large ? 'ispinner-large' : ''} ${this.props.className}`}>
            {Spinner._renderBlades()}
        </div>
    }

    /**
     * _renderBlades
     * @private
     */
    private static _renderBlades(): Array<JSX.Element> {
        let blades: Array<JSX.Element> = [];

        for (let i = 0; i < BLADES_NUMBER; ++i) {
            blades.push(<div key={i} className="ispinner-blade"/>);
        }

        return blades;
    }
}